import {Component, OnInit} from '@angular/core';
import {ErrorPageModel} from '../../../models/ErrorPageModel';
import {ErrorPageService} from '../../services/error-page.service';

@Component
({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit
{
  private _errorPageModel: ErrorPageModel;
  private _mostrarAccesoDenegado: boolean;
  private _mostrarServicioNoDisponible: boolean;

  constructor(private errorPageService: ErrorPageService)
  {

  }

  get errorPageModel(): ErrorPageModel
  {
    return this._errorPageModel;
  }

  set errorPageModel(value: ErrorPageModel)
  {
    this._errorPageModel = value;
    this.actualizarPaginaDeErrorSegunErrorCode(value);
  }

  get mostrarAccesoDenegado(): boolean
  {
    return this._mostrarAccesoDenegado;
  }

  set mostrarAccesoDenegado(value: boolean)
  {
    this._mostrarAccesoDenegado = value;
  }

  get mostrarServicioNoDisponible(): boolean
  {
    return this._mostrarServicioNoDisponible;
  }

  set mostrarServicioNoDisponible(value: boolean)
  {
    this._mostrarServicioNoDisponible = value;
  }

  ngOnInit(): void
  {
    this._errorPageModel = new ErrorPageModel(0, '');

    this.errorPageService.cambioEnErrorPageModelEvent.subscribe((errorPageModel) =>
    {
      this.errorPageModel = errorPageModel;
    });
  }

  private actualizarPaginaDeErrorSegunErrorCode(errorPageModel: ErrorPageModel): void
  {
    let errorCode: number = errorPageModel.codigoError;
    this.mostrarAccesoDenegado = false;
    this.mostrarServicioNoDisponible = false;

    switch (errorPageModel.codigoError)
    {
      case 0:
        errorCode = 503;
        this.mostrarServicioNoDisponible = true;
        break;
      case 403:
        this.mostrarAccesoDenegado = true;
        break;
      case 404:
        break;
      case 503:
        break;
      default:
        break;
    }

    // document.documentElement.style.setProperty('--toto', 'green');
    document.documentElement.style.setProperty('--error-code', errorCode.toString());
  }
}
